'use client'

import * as React from 'react'

const MOBILE_BREAKPOINT = 768

let mobileQuery: MediaQueryList | undefined
const getMobileQuery = () => (mobileQuery ??= window.matchMedia(`(width < ${MOBILE_BREAKPOINT}px)`))

const subscribe = (onChange: () => void) => {
  const query = getMobileQuery()
  query.addEventListener('change', onChange)
  return () => query.removeEventListener('change', onChange)
}

// React reads the snapshot after every commit. `window.innerWidth` can lay the page out first, which
// the commit has just invalidated; the media query's answer needs no layout.
const getSnapshot = () => getMobileQuery().matches

const getServerSnapshot = () => false

export function useIsMobile() {
  return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
